export default __webpack_public_path__ + "bd684a0f584edd176188dd0a1aec7683.svg";